import React, { useState, useContext } from 'react';
import { FiX, FiCheck, FiZap, FiTrendingUp, FiMessageSquare, FiUsers, FiShoppingBag, FiFileText } from 'react-icons/fi';
import AuthContext from '../context/AuthContext';
import PaymentModal from './PaymentModal';

const UpgradeModal = ({ isOpen, onClose }) => {
  const { user } = useContext(AuthContext);
  const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [selectedPrice, setSelectedPrice] = useState(0);

  const handleSelectPlan = (planName, price) => {
    setSelectedPlan(planName);
    setSelectedPrice(price);
    setIsPaymentModalOpen(true);
  };

  if (!isOpen) return null;

  const isPro = user?.plan === 'pro';

  // Sinon, on rend le contenu de UpgradeModal avec son propre arrière-plan.
  return (
    <>
    <div className={`fixed inset-0 bg-black bg-opacity-60 backdrop-blur-sm z-[60] flex justify-center items-center p-4 ${isPaymentModalOpen ? 'hidden' : ''}`}>
      <div className={`bg-white p-8 rounded-lg shadow-xl w-full ${isPro ? 'max-w-md' : 'max-w-2xl'} my-auto`}>
        {/* Le contenu de UpgradeModal */}
        <div className="flex justify-between items-center mb-6">
        <h3 className="text-2xl font-bold text-gray-800 flex items-center">
          <FiZap className="text-yellow-400 mr-2" />
          Passez au niveau supérieur
        </h3>
        <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
          <FiX size={24} />
        </button>
      </div>
        
      <p className="text-gray-600 mb-8 text-center">
        {isPro ? "Passez à la vitesse supérieure avec les fonctionnalités Premium." : "Choisissez le plan qui vous aidera à mieux vendre et à mieux gérer."}
      </p>

      <div className={`grid grid-cols-1 ${isPro ? '' : 'md:grid-cols-2'} gap-6`}>
        {/* Plan Pro */}
        {!isPro && (
          <div className="bg-gray-50 p-6 rounded-xl border-2 border-brand-green flex flex-col">
            <h4 className="text-xl font-bold text-gray-900">Plan Pro</h4>
            <p className="text-gray-500 text-sm">Idéal pour encaisser plus vite</p>
            <p className="text-4xl font-extrabold my-4 text-gray-900">7,500 <span className="text-lg font-medium text-gray-500">CFA/mois</span></p>
            <ul className="space-y-3 text-gray-700 mb-6 flex-grow">
              <li className="flex items-start"><FiCheck className="text-brand-green mr-2 mt-1 flex-shrink-0" /> <div><strong>Jusqu'à 250 produits & Import Excel</strong><p className="text-xs text-gray-500">Gérez un stock plus important facilement.</p></div></li>
              <li className="flex items-start"><FiFileText className="text-brand-green mr-2 mt-1 flex-shrink-0" /> <div><strong>Tickets & Factures Pro</strong><p className="text-xs text-gray-500">Impression et partage professionnel.</p></div></li>
              <li className="flex items-start"><FiMessageSquare className="text-brand-green mr-2 mt-1 flex-shrink-0" /> <div><strong>Rappels Dettes (WhatsApp & SMS*)</strong><p className="text-xs text-gray-500">Relancez vos clients. <em className="text-orange-500">*SMS en développement</em></p></div></li>
              <li className="flex items-start"><FiTrendingUp className="text-brand-green mr-2 mt-1 flex-shrink-0" /> <div><strong>Rapports & Fournisseurs</strong><p className="text-xs text-gray-500">Analysez vos ventes et gérez vos achats.</p></div></li>
            </ul>
            <button onClick={() => handleSelectPlan('Pro', 7500)} className="w-full text-center bg-brand-green text-white font-bold py-3 px-4 rounded-lg hover:bg-green-600 transition-colors shadow-md">
              Choisir le plan Pro
            </button>
          </div>
        )}
        {/* Plan Premium */}
        <div className="bg-gray-800 text-white p-6 rounded-xl border flex flex-col">
          <h4 className="text-xl font-bold">Plan Premium</h4>
          <p className="text-gray-400 text-sm">Pour structurer et déléguer</p>
          <p className="text-4xl font-extrabold my-4">25,000 <span className="text-lg font-medium text-gray-400">CFA/mois</span></p>
          <ul className="space-y-3 text-gray-300 mb-6 flex-grow">
            {!isPro && <li className="flex items-center"><FiCheck className="text-brand-green mr-2" /> <strong>Tout le plan Pro, et plus :</strong></li>}
            <li className="flex items-start"><FiShoppingBag className="text-brand-green mr-2 mt-1 flex-shrink-0" /> <div><strong>Boutique en ligne</strong><p className="text-xs text-gray-400">Vendez sur internet simplement.</p></div></li>
            <li className="flex items-start"><FiCheck className="text-brand-green mr-2 mt-1 flex-shrink-0" /> <div><strong>Produits illimités</strong><p className="text-xs text-gray-400">Aucune limite de stock.</p></div></li>
            <li className="flex items-start"><FiUsers className="text-brand-green mr-2 mt-1 flex-shrink-0" /> <div><strong>Gestion d'Équipe</strong><p className="text-xs text-gray-400">Invitez vos employés et gérez les accès.</p></div></li>
            <li className="flex items-start"><FiTrendingUp className="text-brand-green mr-2 mt-1 flex-shrink-0" /> <div><strong>Rapports Avancés & Dettes Fournisseurs</strong><p className="text-xs text-gray-400">Exports Excel/PDF et suivi complet.</p></div></li>
          </ul>
          <button onClick={() => handleSelectPlan('Premium', 25000)} className="w-full text-center bg-gray-600 text-white font-bold py-3 px-4 rounded-lg hover:bg-gray-500 transition-colors shadow-md">
            Choisir le plan Premium
          </button>
          </div>
      </div>
      </div>
    </div>
    <PaymentModal 
        isOpen={isPaymentModalOpen} 
        onClose={() => setIsPaymentModalOpen(false)} 
        planName={selectedPlan} 
        price={selectedPrice} 
    />
    </>
  );
};

export default UpgradeModal;